import React, { forwardRef, useState } from "react"
import ContextMenu from "../../../components/atoms/ContextMenu.atom"
import {
  isVacationRequestApproved,
  isVacationRequestCanceled,
  isVacationRequestPending,
} from "../../../utils/vacation.utils"
import {
  MY_VACATION_STATES,
  VACATIONS_SAVE_ERROR_MESSAGE,
  VACATIONS_SAVE_SUCCESS_MESSAGE,
} from "../../../consts/modules/vacations.consts"
import { cancelVacationRequest } from "../../../services/vacation.service"
import useToast from "../../../hooks/useToast.hook"

const TeamMemberVacationRequestsContextMenu = forwardRef(
  (
    {
      vacationRequest,
      setVisibleModal,
      triggerRefresh,
      submittingCancel,
      setSubmittingCancel,
    },
    ref
  ) => {
    const { setSuccessMessage, setErrorMessage } = useToast()
    let items = []
    if (vacationRequest && isVacationRequestPending(vacationRequest)) {
      items = [
        {
          label: "Editar",
          icon: "pi pi-pencil",
          command: () => {
            setVisibleModal(MY_VACATION_STATES.CHANGE_PENDING)
          },
        },
        {
          label: "Cancelar",
          icon: "pi pi-trash",
          disabled: submittingCancel,
          command: async (e) => {
            await handleCancelByTeamMember()
          },
        },
      ]
    }
    if (vacationRequest && isVacationRequestApproved(vacationRequest)) {
      items = [
        {
          label: "Solicitar cambio",
          icon: "pi pi-pencil",
          command: () => {
            setVisibleModal(MY_VACATION_STATES.CHANGE_APPROVED)
          },
        },
      ]
    }
    const handleCancelByTeamMember = async () => {
      if (!vacationRequest) return

      setSubmittingCancel(true)
      try {
        const response = await cancelVacationRequest(
          vacationRequest.idVacations
        )
        if (!response.success) {
          throw new Error(response.message)
        }
        triggerRefresh()
        setSuccessMessage(VACATIONS_SAVE_SUCCESS_MESSAGE)
      } catch (error) {
        setErrorMessage(VACATIONS_SAVE_ERROR_MESSAGE)
      } finally {
        setSubmittingCancel(false)
      }
    }
    return <ContextMenu ref={ref} model={items} />
  }
)

export default TeamMemberVacationRequestsContextMenu
